import type { CSSProperties } from 'react';

import classNames from 'classnames';

import { useAnchorable } from '../../hooks/useAnchorable';

import { paragraph, paragraphContainer } from './Paragraph.css';
import type { PostParagraphProps } from './Paragraph.types';

export {
  paragraph as postParagraphClass,
  paragraphContainer as postParagraphContainerClass,
} from './Paragraph.css';

const Paragraph = ({ children, className, element }: PostParagraphProps) => {
  const { textAlign } = element.attrs || {};
  const { anchorAttributes } = useAnchorable(element.attrs);

  return (
    <div className={paragraphContainer} {...anchorAttributes}>
      <p
        className={classNames(className, paragraph)}
        style={
          {
            '--text-align': textAlign,
          } as CSSProperties
        }
      >
        {children}
      </p>
    </div>
  );
};

export { Paragraph };
